<footer *ngIf="footer.show" class="zest-footer center">
  <div *ngIf="application && application.MerchantName && footer.backToMerchant" id="backToMerchant" class="modal" materialize="modal" [materializeParams]="[{dismissible: false}]">
    <div class="modal-content text-left">
      <p *ngIf="!footer.cancelOrder" [textContent]="'Are you sure you want to go back to ' + application.MerchantName + '?'"></p>
      <p *ngIf="footer.cancelOrder" [textContent]="'Are you sure you want to go back to ' + application.MerchantName + '? This will cancel your current loan application.'"></p>
    </div>
    <div class="modal-footer text-right">
      <button type="button" (click)="backToMerchant()" class="btn btn-flat modal-btn modal-action modal-close waves-effect" [textContent]="'Yes'"></button>
      <button type="button" (click)="closeModal()" class="btn zest-btn-2 modal-btn modal-action modal-close waves-effect" [textContent]="'No'"></button>
    </div>
  </div>
  <div *ngIf="footer.testimonial" class="row zest-row no-margin">
    <div class="col s12">
      <zest-testimonials></zest-testimonials>
      <div class="clr"></div>
      <hr class="testimonials-hr">
    </div>
  </div>
  <div class="row no-margin">
    <div *ngIf="footer.backToMerchant && application && application.MerchantName" class="center" [class.back]="footer.popup" [class.forward]="!footer.popup">
      <div class="cursor-auto" *ngIf="footer.popup">
        <img class="img" src="../../assets/images/back.png" (click)="showModal()" />
        <div class="text" [textContent]="'Back to ' + application.MerchantName" (click)="showModal()"></div>
      </div>
      <div *ngIf="!footer.popup">
        <div class="text" [textContent]="'Proceed to ' + application.MerchantName" (click)="showModal()"></div>
        <img class="img" src="../../assets/images/back.png" (click)="showModal()" />
      </div>
      <div class="margin-bottom-footer"></div>
    </div>
    <div *ngIf="footer.logo" class="logo">
      <img src="../../assets/images/footer.png" />
    </div>
  </div>
</footer>